
export default [
	{
		path: 'industryAlliance',
		name: 'industryAlliance',
		component: function (resolve) {
			require(['../views/industryAlliance/index.vue'], resolve)
		},
	},
]